import httpClient from './httpClient'

const AccountAuthAPI = {
  get(callback) {
    /** 呼び出すときはここにパラメータをわたす */
    httpClient.get('/account/auth?account_id=1').then(response => {
      callback(response)
    })
  },
}

export default AccountAuthAPI
